import { LegacyVoiceOption as VoiceOption } from "@/constants/audioVoice";
import { FaPlay, FaPause } from "react-icons/fa";

export enum AudioState {
  PLAYING = "playing",
  PAUSED = "paused",
  INITIAL = "initial",
}

const CompactVoice = ({
  voice,
  audioRef,
  audioState,
  isHovered = false,
  onIconClick,
}: {
  voice: VoiceOption;
  audioRef: React.RefObject<HTMLAudioElement>;
  audioState: AudioState;
  isHovered?: boolean;
  onIconClick?: () => void;
}) => {
  const shouldShowEffects =
    isHovered &&
    audioState !== AudioState.INITIAL &&
    (audioState === AudioState.PLAYING || audioState === AudioState.PAUSED);

  return (
    <div className="flex flex-row items-center gap-4">
      <audio ref={audioRef} preload="auto" />
      <div
        className="relative w-[60px] h-[60px] lg:w-[77px] lg:h-[77px] rounded-full overflow-hidden cursor-pointer flex-shrink-0"
        onClick={() => {
          onIconClick?.();
        }}
      >
        <img
          src={voice.icon}
          alt={voice.label}
          className={`w-full h-full object-cover transition-all duration-200 ${shouldShowEffects ? "blur-sm" : ""}`}
        />
        {shouldShowEffects && (
          <div
            className="absolute inset-0 flex items-center justify-center pointer-events-auto"
            onClick={() => {
              onIconClick?.();
            }}
          >
            {audioState === AudioState.PLAYING ? (
              <FaPause className="xs:w-6 xs:h-6 sm:w-8 sm:h-8 text-white" />
            ) : (
              <FaPlay className="xs:w-6 xs:h-6 sm:w-8 sm:h-8 text-white" />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default CompactVoice;
